/**
 * Regra de "nome completo" usada nos formulários de cadastro do candidato.
 * Espelha `apps/api/src/lib/candidateRequirements.ts` (gate de candidatura) e a validação
 * do Node-RED em `candidate/register` e `candidate/registerData` — os três precisam
 * aceitar/rejeitar exatamente os mesmos nomes.
 */

export const FULL_NAME_MESSAGE = 'Preencha o nome completo (nome e sobrenome)';

/** Partículas que não contam como sobrenome ("Maria de" não é nome completo). */
const NAME_PARTICLES = ['de', 'da', 'do', 'das', 'dos', 'e', 'di', 'du', 'del', 'della', 'van', 'von', 'la', 'le'];

/**
 * Nome completo = pelo menos dois blocos alfabéticos significativos e nenhum dígito.
 * Aceita "Ana Sá" e "Maria de Souza"; rejeita "Maria" e "Maria 2".
 */
export const isFullName = value => {
	if (typeof value !== 'string') {
		return false;
	}

	const name = value.trim();

	if (name.length === 0 || /\d/.test(name)) {
		return false;
	}

	const meaningfulParts = name
		.split(/\s+/)
		.map(part => part.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, ''))
		.filter(part => part.length >= 2 && !NAME_PARTICLES.includes(part.toLowerCase()));

	return meaningfulParts.length >= 2;
};

/** Teste para o yup: campo vazio fica a cargo do `required`. */
export const fullNameTest = value => value == null || value.trim() === '' || isFullName(value);

export default isFullName;
